/**
* functions common matomo
*
* @category   Javascript
* @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
* @copyright  2025 Jakob Ohlsen
*/
import { delayedFunction } from '@ts/common/timeout';
export function initializeMatomo(visitorId, userId, pings) {
    const _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    // _paq.push(["setDoNotTrack", true]); // would enforce do not track option client side - not needed - using server side settings
    // _paq.push(['resetUserId']);
    if (visitorId) {
        // console.log('setVisitorId', visitorId)
        // _paq.push(['setVisitorId', visitorId]);
        _paq.push(['appendToTrackingUrl', 'cid=' + visitorId]);
    }
    if (userId) {
        // console.log('setUserId', userId)
        _paq.push(['setUserId', userId]);
    }
    _paq.push(["disableCookies"]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    const matomoPushElements = document.querySelectorAll('[data-matomo-push]');
    matomoPushElements.forEach(function (currentValue) {
        _paq.push(JSON.parse(currentValue.dataset.matomoPush));
    });
    (function () {
        const u = "//analytics.ai-diagnostics.net/";
        _paq.push(['setTrackerUrl', u + 'matomo.php']);
        _paq.push(['setSiteId', '1']);
        const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = u + 'matomo.js';
        s.parentNode.insertBefore(g, s);
        g.addEventListener('load', function () {
            // console.log('initializedMatomo load event');
            const initializedMatomoEvent = new Event('initializedMatomo');
            document.dispatchEvent(initializedMatomoEvent);
        });
    })();
    if (pings) {
        delayedFunction(pings, (t) => {
            // console.log(`Ping called after ${t/1000} seconds`)
            const _paq = window._paq = window._paq || [];
            _paq.push(['ping']);
        });
    }
}
export function logMatomo(visitorId, userId) {
    if (visitorId)
        console.log('logMatomo - v', visitorId);
    if (userId)
        console.log('logMatomo - u', userId);
    const matomoPushElements = document.querySelectorAll('[data-matomo-push]');
    matomoPushElements.forEach(function (currentValue) {
        console.log(JSON.parse(currentValue.dataset.matomoPush));
    });
}
